export default __webpack_public_path__ + "static/media/BTMEARLYYEARS.9392c671.png";